import { render, staticRenderFns } from "./DataGridClearAllButton.vue?vue&type=template&id=4899d26a&scoped=true&"
import script from "./DataGridClearAllButton.vue?vue&type=script&lang=js&"
export * from "./DataGridClearAllButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4899d26a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSlideXTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VBtn,VSlideXTransition})
